export const sendEventToAdobe = (eventName: string, ...detail: any[]) => {
  (window as any)?.SendAdobeData?.(eventName, ...detail);
};
